module.exports = __webpack_public_path__ + "static/img/default_recruit.b06ff7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/default_recruit.jpg
// module id = bz/Y
// module chunks = 0